// Instanced mesh helpers.
import * as THREE from 'three';
import { pick } from './random.js';
import { scene } from '../core/scene.js';

export function instancedRaw(geo, mat, list, place, colorOf) {
  const im = new THREE.InstancedMesh(geo, mat, list.length),
    o = new THREE.Object3D(),
    col = new THREE.Color();
  list.forEach((it, i) => {
    o.position.set(0, 0, 0);
    o.rotation.set(0, 0, 0);
    o.scale.set(1, 1, 1);
    place(o, it);
    o.updateMatrix();
    im.setMatrixAt(i, o.matrix);
    if (colorOf) im.setColorAt(i, col.set(colorOf(it)));
  });
  im.castShadow = im.receiveShadow = true;
  return im;
}
export function instanced(geo, mat, list, place, colors) {
  const im = new THREE.InstancedMesh(geo, mat, list.length),
    o = new THREE.Object3D(),
    col = new THREE.Color();
  list.forEach((it, i) => {
    o.position.set(0, 0, 0);
    o.rotation.set(0, 0, 0);
    place(o, it);
    o.updateMatrix();
    im.setMatrixAt(i, o.matrix);
    if (colors) im.setColorAt(i, col.set(pick(colors)));
  });
  im.castShadow = im.receiveShadow = true;
  scene.add(im);
  return im;
}
